// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_PACKAGE_CATEGORY,
	SETTING_CREATE_PACKAGE_CATEGORY_SUCCESS,
	SETTING_UPDATE_PACKAGE_CATEGORY,
	SETTING_UPDATE_PACKAGE_CATEGORY_SUCCESS,
	SETTING_LOAD_PACKAGE_CATEGORY,
	SETTING_LOAD_PACKAGE_CATEGORY_SUCCESS,
	SETTING_DELETE_PACKAGE_CATEGORY,
	SETTING_DELETE_PACKAGE_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_PACKAGE,
	SETTING_LOAD_PACKAGE_SUCCESS,
	SETTING_CREATE_PACKAGE,
	SETTING_CREATE_PACKAGE_SUCCESS,
	SETTING_UPDATE_PACKAGE,
	SETTING_UPDATE_PACKAGE_SUCCESS,
	SETTING_DELETE_PACKAGE,
	SETTING_DELETE_PACKAGE_SUCCESS,
	SETTING_UPDATE_PACKAGE_STATUS,
	SETTING_UPDATE_PACKAGE_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	packageLoading: false,
	packageCategoryLoading: false,
	packageCategory: [],
	optionPackageCategory: [],
	packageList: [],
	optionPackage: [],

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_PACKAGE_CATEGORY:
			return { ...state, packageCategoryLoading: true, }
		case SETTING_LOAD_PACKAGE_CATEGORY_SUCCESS:
			return {
				...state,
				packageCategoryLoading: false,
				packageCategory: action.payload,
				optionPackageCategory: action.payloadlist
			}
		case SETTING_CREATE_PACKAGE_CATEGORY:
			return { ...state, packageCategoryLoading: true }
		case SETTING_CREATE_PACKAGE_CATEGORY_SUCCESS:
			return { ...state, packageCategoryLoading: false }
		case SETTING_UPDATE_PACKAGE_CATEGORY:
			return { ...state, packageCategoryLoading: true }
		case SETTING_UPDATE_PACKAGE_CATEGORY_SUCCESS:
			return { ...state, packageCategoryLoading: false }
		case SETTING_DELETE_PACKAGE_CATEGORY:
			return { ...state, packageCategoryLoading: true }
		case SETTING_DELETE_PACKAGE_CATEGORY_SUCCESS:
			return { ...state, packageCategoryLoading: false }
		case SETTING_LOAD_PACKAGE:
			return { ...state, packageLoading: true, }
		case SETTING_LOAD_PACKAGE_SUCCESS:
			return {
				...state,
				packageLoading: false,
				packageList: action.payload,
				optionPackage: action.payloadlist
			}
		case SETTING_CREATE_PACKAGE:
			return { ...state, packageLoading: true }
		case SETTING_CREATE_PACKAGE_SUCCESS:
			return { ...state, packageLoading: false }
		case SETTING_UPDATE_PACKAGE:
			return { ...state, packageLoading: true }
		case SETTING_UPDATE_PACKAGE_SUCCESS:
			return { ...state, packageLoading: false }
		case SETTING_DELETE_PACKAGE:
			return { ...state, packageLoading: true }
		case SETTING_DELETE_PACKAGE_SUCCESS:
			return { ...state, packageLoading: false }
		case SETTING_UPDATE_PACKAGE_STATUS:
			return { ...state, packageLoading: true }
		case SETTING_UPDATE_PACKAGE_STATUS_SUCCESS:
			return { ...state, packageLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				packageLoading: false,
				packageCategoryLoading: false,
				packageCategory: [],
				optionPackageCategory: [],
				packageList: [],
				optionPackage: [],
			};

		default: return { ...state };
	}
}